import {atImgPath} from '../atBrowserUtils'

/**
 * @deprecated see "components/TumblerSwitch"
 */
function TumblerSwitch( enabled, switchCallback, small )
{
    this.small = small;
    this.switchCallback = switchCallback;
    this.img = document.createElement("IMG");

    if( enabled )
        this.setEnabled();
    else
        this.setDisabled();

    var me = this;
    this.img.onclick = function() { me.callback(); }
}

TumblerSwitch.prototype.isEnabled = function()
{
    return this.enabled;
};

TumblerSwitch.prototype.render = function( elementId )
{
    this.appendAsChildTo( document.getElementById( elementId ) );
};

TumblerSwitch.prototype.appendAsChildTo = function( elementObj )
{
    if( elementObj )
        elementObj.appendChild( this.img );
};

TumblerSwitch.prototype.callback = function()
{
    if( this.enabled )
        this.setDisabled();
    else
        this.setEnabled();
    this.switchCallback( this.enabled );
};

TumblerSwitch.prototype.setEnabled = function()
{
    this.enabled = true;
    this.img.className = "tumblerSwitch move on" + (this.small ? " small" : "");
    this.img.src = atImgPath( this.small ? "switcher_small_fg_on.png" : "switcher_fg_on.png" );
};

TumblerSwitch.prototype.setDisabled = function()
{
    this.enabled = false;
    this.img.className = "tumblerSwitch move off" + (this.small ? " small" : "");
    this.img.src = atImgPath( this.small ? "switcher_small_fg_off.png" : "switcher_fg_off.png" );
};

export default TumblerSwitch



// WEBPACK FOOTER //
// ./web/js/controls/tumbler_switch.js